import { v4 as uuid } from "uuid";
import DossierAPI from "@/api/DossierAPI";
import WPAPI from "@/api/WPAPI";

import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {SCHEDULE} from "@/actions/globalConst";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";

import moment from 'moment';
import CalenderHelperClass from '@/helpers/CalenderHelper'
import StorageHelperClass, {STORAGE} from '@/helpers/StorageHelper'
import {TaskScheduleModel} from '@/models/TaskSchedule';
import {TaskUser} from '@/models/TaskUsers';

import DB from "@/models/DB";



export const initialState = {
    dossierScheduleItems: DB.newCollection(),
    initItems: [],
    userScheduleItems: {},
    apiState: SCHEDULE.API_INIT,
    selectedTask: {},
    key: "",
    error: null
};

let dossierScheduleItems = StorageHelperClass.get(STORAGE.SCHEDULE);
if(dossierScheduleItems) {
    initialState.dossierScheduleItems = DB.newCollection(JSON.parse(dossierScheduleItems));
    /*
    
        let newDossierScheduleItems = {};
    if(dossierScheduleItems) {
        Object.keys(dossierScheduleItems).map((taskKey, taskIndex) => {
            let taskScheduleModel = new TaskScheduleModel();
            taskScheduleModel.syncData({...dossierScheduleItems[taskKey]});
            
            newDossierScheduleItems[taskKey] = taskScheduleModel;
        });
    }
    */
    
    
/*    
    let task = initialState.dossierScheduleItems.where('taskKey', 'mJPkAwFH7D-52595996856689').get(true);
    let r= task.first();
    r.workhours = 22;
    console.info("INIT!!!1", task);
    console.info("INIT!!!1", initialState.dossierScheduleItems);
    */
    //initialState.apiState = SCHEDULE.API_READY;
//    } else {
//        localStorage.removeItem("schedule");
//    }
}

const createScheduleTask=(state,dossier, task, user, day) => {
   let taskKey = task.key;
   let taskScheduleModel;
   let scheduleItem = new TaskUser({dossierKey: dossier.key, userKey: user.key, taskKey: task.key, dayKey: day.daykey, startTime: moment(day.daykey,'YYYYMMDD').unix(), workhours: 0, workhours_type: ""});
   //let scheduleItem = DB.newModel(taskUser);
    state.dossierScheduleItems.set(scheduleItem);   
   
//   state.dossierScheduleItems = {
//       ...current(state.dossierScheduleItems),
//       [taskKey]: taskScheduleModel
//       };
       
       
//   state.userScheduleItems = {
//       ...current(state.userScheduleItems),
//       [user.key]: taskScheduleModel.getUserForKey(user.key)
//       };
       
//    state.apiState = SCHEDULE.API_READY;
    state.key = uuid().slice(0, 8);
//    state.error = null;
    //return state;
           
       
   //localStorage.setItem("schedule", JSON.stringify(state.dossierScheduleItems));
}

const rejectEventHandlerSchedule=((state, action) => {
    state.apiState = SCHEDULE.API_READY;
    state.error = action.payload;
    state.key = uuid().slice(0, 8);

});
const pendingEventHandlerSchedule=((state, action) => {
    state.apiState = SCHEDULE.API_PROCESSING;
    state.key = uuid().slice(0, 8);
    
})
let fullFilledEventHandlerSchedule= ( (state, action) => {
    
    if(action.type == "schedule_store/fulfilled") {
        //localStorage.removeItem("schedule");
        StorageHelperClass.del(STORAGE.SCHEDULE)
    }
    //;
    state.apiState = SCHEDULE.API_READY;
    state.key = uuid().slice(0, 8);
    state.error = null;
    return state;
})
let task = null;
const ScheduleReducer = createSlice({
  name: 'Schedule',
  initialState,
  reducers: {
      deleteUserTask:  ((state = null, action = null) => {
            state.key = uuid().slice(0, 8);
//            localStorage.setItem("schedule", JSON.stringify(state.dossierScheduleItems));
            StorageHelperClass.set(STORAGE.SCHEDULE, (state.dossierScheduleItems));   
          }),
      setSelectedTask:  ((state = null, action = null) => {
              state.selectedTask = action.payload.selectedTask;
              state.key = uuid().slice(0, 8);
              state.error = null;
              return state;
        }),
      updateScheduleItems:  ((state = null, action = null) => {
          if(action.payload.taskScheduleModel) {
              let taskKey = action.payload.taskScheduleModel.taskKey;
               state.dossierScheduleItems = {
                ...state.dossierScheduleItems,
                [taskKey]: action.payload.taskScheduleModel
                };
//            localStorage.setItem("schedule", JSON.stringify(state.dossierScheduleItems));
            StorageHelperClass.set(STORAGE.SCHEDULE, (state.dossierScheduleItems));   
          }
//        state.apiState = SCHEDULE.API_READY;
//        state.selected = null;
//      state.key = uuid().slice(0, 8);
//          return state;
      }),
      createScheduleItem:  ((state = null, action = null) => {
          let dossier = action.payload.dossier;
          let task = action.payload.task;
          let user = action.payload.user;
          let day = action.payload.day;
          createScheduleTask(state,dossier, task, user, day);
          
          StorageHelperClass.set(STORAGE.SCHEDULE, (state.dossierScheduleItems));
//        state.apiState = SCHEDULE.API_READY;
//        state.selected = null;
//      state.key = uuid().slice(0, 8);
//         return state; 
      }) 
    // omit existing reducers here
  },
  extraReducers(builder) {
    task = saveScheduleTasks2;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));

    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {

        state.scheduleItems = [];
        state.apiState = SCHEDULE.API_INIT
        state.key = "";
          state.error = null;
       })

    builder.addMatcher(
      (action) => action.type == "CommunicationCycle/cancelSchedule",
      (state, action) => {

        state.dossierScheduleItems = TaskUser.createCollection(state.items, TaskUser);
        state.apiState = SCHEDULE.API_READY;
        state.key = uuid().slice(0, 8);
        state.error = null;
       })

       
    builder.addMatcher(
      (action) => action.type == "get_dossier/fulfilled",
      (state, action) => {
        let items = null;
        let item = null;
        if(action.payload.data.dossier) {
            items = action.payload.data.dossier;
        } else if(action.payload.data?.data?.data?.items) {
            items = action.payload.data.data.data.items;
            }
          
          if(items) {
            state.items = items;
            state.dossierScheduleItems = TaskUser.createCollection(items.children, TaskUser);
          }
          
          console.debug("action.payload.data.data.data", state.dossierScheduleItems)
        if(action.payload?.data?.data?.data) {
//         let items = action.payload.data.data.data.items;
 //        state.items = action.payload.data.data.data.items;
  //       state.dossierScheduleItems = TaskUser.createCollection(items, TaskUser);
/*         }
         for(let i in items) {
             let taskScheduleModel = new TaskScheduleModel();
             taskScheduleModel.syncData(items[i]);
             
   state.dossierScheduleItems = {
       ...state.dossierScheduleItems,
       [taskScheduleModel.taskKey]: taskScheduleModel
       };
             
             
             
         }
        //state.dossierScheduleItems
  */           
        
    //    
        }
        state.apiState = SCHEDULE.API_READY;
        state.key = uuid().slice(0, 8);
        state.error = null;
       })
       

    
  }
  })

export const saveScheduleTasks2 = createAsyncThunk(SCHEDULE.ACTION_STORE, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.storeSchedule(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    
    return response.data;
  }
)

export const { createScheduleItem, updateScheduleItems, setSelectedTask,deleteUserTask } = ScheduleReducer.actions;
export default ScheduleReducer.reducer